import { useState } from 'react'
import { ObjectBrowseField } from './ObjectBrowseField'
import { PersonPickerModal, type PersonPickValue } from './PersonPickerModal'

type Props = {
  value?: PersonPickValue | null
  onChange?: (value: PersonPickValue | null) => void
  disabled?: boolean
  className?: string
}

export function OrgPersonBrowseField({ value, onChange, disabled, className }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <ObjectBrowseField
        name={value?.name}
        placeholder="请选择人员"
        disabled={disabled}
        ariaLabel="选择人员"
        className={className}
        onBrowse={() => setOpen(true)}
      />
      <PersonPickerModal
        open={open}
        value={value}
        onCancel={() => setOpen(false)}
        onConfirm={(next) => {
          onChange?.(next)
          setOpen(false)
        }}
      />
    </>
  )
}
